const CartUtil = {
    checkLoginAndGoToCheckout: function (isMiniCart) {
        CartUtil.sendAnalytics(isMiniCart);
        if (!isAuthenticated) {
            CartUtil.loadLogin();
        } else {
            CartSummary.disableCheckout(true);
        }
        MiniCart.setRedirectingToCheckout(true);
        MiniCart.closeModal();
    },

    checkTimeslotAndGoToCheckout: function (obj, isMiniCart) {
        if (CartUtil.isTimeslotCheckEnabled() && typeof serviceUrl !== 'undefined' && typeof cartWithoutTimeslot != 'undefined' && cartWithoutTimeslot
            && typeof serviceType !== 'undefined' && serviceType !== 'cornershop_home_delivery') {
            ServiceTimeslot.openServiceAndGoToCheckout(obj, serviceUrl);
        } else {
            CartUtil.checkLoginAndGoToCheckout(isMiniCart);
        }
    },

    loadLogin: function () {
        CartUtil.goToCheckout();
    },

    sendAnalytics: function (isMiniCart) {
        pushCheckoutProductsMetrics(isMiniCart ? '.mini--cart--product' : '.product-card', 1, isAuthenticated ? CartUtil.goToCheckout : null, true);
    },

    goToCheckout: function () {
        window.location.href = checkoutUrl;
    },

    isTimeslotCheckEnabled: function () {
        return typeof timeslotCheckEnabled !== 'undefined' && timeslotCheckEnabled === 'true';
    }
};